import { RoleService } from '../services/RoleService';

export function useRoleService(): RoleService {
  return new RoleService(useApiClient(), useUserStore());
}
